@use '@helsenorge/designsystem-react/scss/spacers' as spacers;
@use '@helsenorge/designsystem-react/scss/palette' as palette;
@use '@helsenorge/designsystem-react/scss/screen-reader' as *;

.scoreinput {
  display: flex;
  border-radius: 50%;
  align-items: center;

  &:hover {
    background-color: rgba(palette.$plum600, 0.1);
  }

  &:focus-within {
    outline: 3px solid palette.$black;
  }

  &--selected {
    background-color: palette.$plum700;

    &:hover {
      background-color: palette.$plum800;
    }
  }

  &__radio,
  &__text {
    @include sr-only;
  }
}
